import { render, staticRenderFns } from "./PatientObservationsCard.vue?vue&type=template&id=1a3f2efc&scoped=true&"
import script from "./PatientObservationsCard.vue?vue&type=script&lang=js&"
export * from "./PatientObservationsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3f2efc",
  null
  
)

export default component.exports